import $i18n from 'panda-i18n';
import React, { useContext, useState } from 'react';
import { CardItemsStateCtx } from '../../context/card-items';
import { CnIcon } from '@/components/cn-icon';
import { CnDialogFullpage } from '@/components/cn-dialog-fullpage';
import { CnPageFooter } from '@/components/cn-page-footer';
import { List } from '../list';
import { Toolbar } from '../toolbar';
import './index.scss';
/** 子卡片列表 */
export const ListSubCard = () => {
    const state = useContext(CardItemsStateCtx);
    const [visible, setVisible] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "cn-ui-m-card-items-sub-list", onClick: () => setVisible(true) },
            React.createElement("div", null, state.listPlaceholder),
            React.createElement(CnIcon, { type: "arrow-right" })),
        React.createElement(CnDialogFullpage, { zIndex: 299, title: $i18n.get({
                id: '31255239428542464.CNTM',
                dm: '详情',
                ns: 'CnCardItems',
            }), visible: visible, onClose: () => setVisible(false), footer: state.showToolbar ? (React.createElement(CnPageFooter, null,
                React.createElement(Toolbar, { ...state }))) : (false) },
            React.createElement(List, null))));
};
